import React from "react";
import EditTable from "../../../components/Components/MilkEditTable";
import { getMilkList } from "../mutations/TransactionsMutation";
import { Grid } from "@mui/material";
import { useQuery } from "react-query";
import Loader from "../../../components/Components/Loader";

function MilkTransaction() {
  const currentTimestamp = Date.now();

  const currentDate = new Date(currentTimestamp);

  const formattedDate = currentDate.toISOString().slice(0, 10);

  const { data: milkData, isLoading } = useQuery(
    "milkTransactions",
    () => getMilkList(formattedDate),
    { refetchOnMount: true }
  );

  console.log({ milkData, isLoading });

  if (isLoading) return <Loader />;

  return (
    <Grid container justifyContent={"center"}>
      <Grid item textAlign={"center"}>
        <h4>Milk Transactions</h4>
      </Grid>
      <Grid item xs={12}>
        <EditTable tableData={milkData ?? []} />
      </Grid>
    </Grid>
  );
}

export default MilkTransaction;
